import React, { useEffect, useState } from "react";
import { Modal, Form, } from "react-bootstrap";

import Select from "react-select";
import { BroadCastNotification } from "../../validate/schedule";
import ErrorFilter from '../../helper/errorFilter';
import SingleError from "../../helper/SingleError";
import { addBroadcastNotification, editBroadcastNotification } from "../../controller";
import { requestHandler } from "../../helper";
import { toast } from "react-toastify";
import { formatDateToLocalInput } from "../../helper/common";
function SendNotificationModal({ show, selectedBroadcast, getNotificationData, setNotificationShow, setSelectedBroadCast }) {
  const [submitCount, setSubmitCount] = useState(0);
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  // const [options, setOptions] = useState([]);
  const requireField = ["title", "desc", "type", "scheduleTime", "userId"];
  const Selectoption5 = [
    { value: '', label: 'Select type' },
    { value: 'all', label: 'All User' },
  ];

  const Selectoption4 = [
    { value: "inApp", label: "In-App Notification" },
    { value: "email", label: "Email Only" },
    { value: "both", label: "Both" }
  ];

  // Initialize form data
  const [broadcastData, setBroadcastData] = useState({
    type: "",
    method: Selectoption4[0].value,
    title: "",
    desc: "",
    scheduleTime: "",
    isScheduled: false,
    userId: []
  });


  useEffect(() => {
    if (selectedBroadcast) {
      setBroadcastData({
        type: selectedBroadcast.type || Selectoption5[0].value,
        method: selectedBroadcast.method || Selectoption4[0].value,
        title: selectedBroadcast.title || "",
        desc: selectedBroadcast.desc || "",
        isScheduled: selectedBroadcast.isScheduled || false,
        scheduleTime: selectedBroadcast?.scheduleTime ? formatDateToLocalInput(selectedBroadcast.scheduleTime) : '',
        userId: selectedBroadcast?.userId || []
      });
      setIsDisabled(true)
    } else {
      setBroadcastData({
        type: "",
        method: Selectoption4[0].value,
        title: "",
        desc: "",
        scheduleTime: "",
        isScheduled: false,
        userId: []
      });
      // setOptions([])
      setIsDisabled(false)

    }
    // eslint-disable-next-line 
  }, [selectedBroadcast]);
  const handleSelectChange = (selectedOption, field) => {
    if (submitCount > 0) {
      let validationError = BroadCastNotification({
        ...broadcastData, [field]: selectedOption ? selectedOption.value : ""
      })

      validationError = ErrorFilter(validationError, requireField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[field];
      }
    }
    setBroadcastData({ ...broadcastData, [field]: selectedOption ? selectedOption.value : "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (submitCount > 0) {
      let validationError = BroadCastNotification({
        ...broadcastData, [name]: value
      })

      validationError = ErrorFilter(validationError, requireField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
    }
    setBroadcastData({ ...broadcastData, [name]: value });
  };

  const handleDateChange = (e) => {
    setBroadcastData((old) => ({ ...old, scheduleTime: e.target.value }));
  };


  const handleSubmit = async () => {
    setSubmitCount(prevCount => prevCount + 1);
    const updateValues = { ...broadcastData }
    let validationError = BroadCastNotification(updateValues);
    validationError = ErrorFilter(validationError, requireField);
    setErrors(validationError);

    const dataObj = broadcastData;

    if (Object.keys(validationError).length === 0) {
      await requestHandler(
        async () => {
          if (selectedBroadcast) {
            return await editBroadcastNotification(dataObj, selectedBroadcast._id);
          } else {

            if (dataObj.type === 'selectedUser') {
              dataObj.userId = dataObj.userId.map((v) => v._id)
            } else {
              dataObj.userId = [];
            }

            return await addBroadcastNotification(dataObj);
          }
        },
        null,
        (res) => {
          toast.success(res.message);
          handleClose();
          getNotificationData();
          setBroadcastData({
            type: "",
            method: Selectoption4[0].value,
            title: "",
            desc: "",
            scheduleTime: "",
            isScheduled: false,
            userId: []
          });
          // setUserList([])
        },
        () => {
          // Handle error
        }
      );
    }
  };

  const handleClose = () => {
    setSelectedBroadCast(null);
    setNotificationShow(false);
    setBroadcastData({
      type: "",
      method: Selectoption4[0].value,
      title: "",
      desc: "",
      scheduleTime: "",
      isScheduled: false,
      userId: []
    });
  }
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title> {selectedBroadcast ? "Edit" : "Add"} Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='theme-select theme-input'>
          <Form.Label>Notification Type</Form.Label>
          <Select
            name="type"
            options={Selectoption5}
            value={Selectoption5.find(option => option.value === broadcastData.type)}
            onChange={(selectedOption) => handleSelectChange(selectedOption, 'type')}
            className="basic-multi-select"
            isDisabled={isDisabled}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                cursor: 'pointer',
              }),
            }}
          // menuPlacement="auto"
          />
        </div>
        <SingleError error={errors?.type} />
        <div className='theme-select theme-input'>
          <Form.Label>Method</Form.Label>
          <Select
            name="method"
            options={Selectoption4}
            value={Selectoption4.find(option => option.value === broadcastData.method)}
            onChange={(selectedOption) => handleSelectChange(selectedOption, 'method')}
            className="basic-multi-select"
            // menuPlacement="auto"
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                cursor: 'pointer',
              }),
            }}
          />
        </div>

        <div className='theme-select theme-input'>
          <Form.Label>Title</Form.Label>
          <Form.Control type="text" placeholder="Enter your title" name="title"
            value={broadcastData.title}
            onChange={handleChange} />
        </div>
        <SingleError error={errors?.title} />
        <div className='theme-select theme-input'>
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your description"
            name="desc"
            value={broadcastData.desc}
            onChange={handleChange}
          />
        </div>
        <SingleError error={errors?.desc} />
        <div className='theme-select theme-input'>
          <Form.Label>Want to schedule?</Form.Label>
          <div className="d-flex align-items-center gap-3 theme-input">
            <Form.Check
              type="radio"
              name="isScheduled"
              value={1}
              label="Yes"
              checked={Number(broadcastData.isScheduled) === 1}
              onChange={handleChange}
              disabled={isDisabled}

            />
            <Form.Check
              type="radio"
              name="isScheduled"
              value={0}
              label="No"
              checked={Number(broadcastData.isScheduled) === 0}
              onChange={handleChange}
              disabled={isDisabled}

            />
          </div>
          {
            Number(broadcastData.isScheduled) === 1 &&
            <div className="col-6">
              <div className="theme-input">
                <Form.Label>Schedule time</Form.Label>
                <Form.Control type="datetime-local" name="scheduleTime" onChange={handleDateChange} value={broadcastData.scheduleTime} />
              </div>
              <SingleError error={errors?.scheduleTime} />
            </div>
          }
        </div>



        <div className="d-sm-flex align-items-center gap-4">
          <button onClick={handleClose} className="btn btn-outline-light w-100">Cancel</button>
          <button className="btn btn-primary w-100 mt-sm-0 mt-2" type="button" onClick={handleSubmit} >Send Notification</button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SendNotificationModal;
